import { AxiosError } from 'axios';
import React from 'react';
import { UseQueryResult } from 'react-query';
import DangerAlert from './ui/DangerAlert';
import Spinner from './ui/Spinner';

type PrettyLoaderProps = {
  useQueryResult: UseQueryResult<any, unknown>;
};

const PrettyLoader: React.FC<PrettyLoaderProps> = (props) => {
  let errorMessage = '';
  if (props.useQueryResult.error) {
    const error = props.useQueryResult.error as AxiosError;
    errorMessage =
      error.response?.data?.message || error.response?.data || error.message || 'Es ist ein Fehler aufgetreten';

    if (typeof errorMessage !== 'string') errorMessage = JSON.stringify(errorMessage);
  }

  return props.useQueryResult.isLoading ? (
    <Spinner />
  ) : props.useQueryResult.error ? (
    <DangerAlert title="Fehler">{errorMessage}</DangerAlert>
  ) : (
    (props.useQueryResult.data && props.children) || <></>
  );
};

export default PrettyLoader;
